"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 导出失败的 Icon
 * url: https://figma-alpha-api.s3.us-west-2.amazonaws.com/images/9d081d13-9dc6-4195-a865-78b1287ade27
 * name: IcMenuFlipVertical
 */
function IcMenuFlipVertical() {
    return null;
}
exports.default = IcMenuFlipVertical;
;
